// Generic action suffixes
export const ACTION_SET_MODAL_STATE = "SET_MODAL_STATE"
export const ACTION_SET_JWT = "SET_JWT"
export const ACTION_APP_LOADED = "APP_LOADED"
export const ACTION_PENDING_APPROVAL = "PENDING_APPROVAL"
export const ACTION_COMPLETED = "COMPLETED"
export const ACTION_FAILED = "FAILED"
export const ACTION_SET_FILTERS = "ACTION_SET_FILTERS"
export const ACTION_SET_NAVIGATE = "SET_NAVIGATE"
export const ACTION_SET_USE_AUTH = "SET_USE_AUTH"